module.exports = __webpack_public_path__ + "img/logo.363fe2c4.svg";